// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"7b0e80b0","453":"d417acfd","834":"e4e57b5c"}[chunkId] + ".chunk.js";
};